var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconLike48Filled = function SvgIconLike48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9 37.7h-1.7c-1.6 0-2.9-1.3-2.9-2.9V21.2c0-1.6 1.3-2.9 2.9-2.9h1.7v19.4ZM37.46 20.19a5.297 5.297 0 0 0-4.06-1.89h-4.63l.63-2.31a5.25 5.25 0 0 0-.9-4.61 5.271 5.271 0 0 0-4.21-2.08h-.58c-1.05 0-2.02.57-2.54 1.49l-3.87 6.97v19.8l2.97.99c.3.1.61.15.92.15h10.48a5.29 5.29 0 0 0 5.22-4.38l1.73-9.8c.27-1.55-.15-3.12-1.16-4.33Z",
    fill: "current"
  })));
};
export default SvgIconLike48Filled;